import styled from 'styled-components';
import { colors as colorsWeb, FlexContainer } from '@taxdown/piccolo-web';
import { pxToRem } from 'Styles/utils/utils';
import { MOBILE_WIDTH } from 'Styles/variables/sizes';

export const ModalContainer = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 99;
  background: ${({ theme: { colors } }) => colors.darken};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ModalContent = styled.div`
  position: relative;
  background-color: ${({ theme: { colors } }) => colors.white};
  border-radius: ${({ theme: { sizing } }) => sizing.fds_borderradius_L};
  min-width: 308px;
  max-width: 394px;
  display: flex;
  flex-direction: column;
  padding: ${({ theme: { sizing } }) => sizing.fds_size_24};
  .PayPalButtons {
    display: flex;
    margin-bottom: ${({ theme: { sizing } }) => sizing.fds_size_16};
  }
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    min-width: 90%;
    max-width: 90%;
  }
`;

export const CloseButton = styled.button`
  cursor: pointer;
  position: absolute;
  right: ${({ theme: { sizing } }) => sizing.fds_size_16};
  top: ${({ theme: { sizing } }) => sizing.fds_size_16};
  svg {
    width: ${({ theme: { sizing } }) => sizing.fds_size_16};
    height: ${({ theme: { sizing } }) => sizing.fds_size_16};
  }
`;

const backgroundColor = {
  payLater: '#3EAF3F',
  oxxo: '#E70020',
  card: colorsWeb.dark_500,
};

export const MethodContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  padding: ${({ theme: { sizing } }) => sizing.fds_size_16};
  border-radius: ${({ theme: { sizing } }) => sizing.fds_borderradius_M};
  background: ${({ type }) => backgroundColor[type]};
  width: 346px;
  height: 45px;
  line-height: 24px;
  ${({ theme: { components } }) => components.chips.fds_c_chips_text_L};
  svg {
    margin-top: 10px;
    margin-bottom: 10px;
  }
  &:hover {
    cursor: pointer;
  }
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    width: auto;
  }
`;

export const KueskiInfo = styled.div`
  display: flex;
  width: ${pxToRem(340)};
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    width: auto;
  }
`;

export const SpinnerContainer = styled(FlexContainer)`
  margin-top: ${pxToRem(50)};
  height: 100%;
`;

export const ListContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  padding: ${({ theme: { spacing } }) => spacing.spacing_08};
  svg {
    margin-top: ${({ theme: { spacing } }) => spacing.spacing_24};
  }
`;

export const IconContainer = styled(FlexContainer)`
  svg {
    margin-top: 0;
    margin-bottom: 10px;
  }
`;
